const activities = `${process.env.VUE_APP_URL}/api/v1/activities/`;
export default {
  namespaced: true,
  state: {
    tableRows: [],
    createActivityData: {
      name: null,
      description: null,
      is_tdabc:false,
      costpool:null,
    },
    modelHasTdabcDriver:false,
  },
  mutations: {
    SET_TABLE_DATA(state, data) {
      state.tableRows = data;
    },
    SET_ACTIVITY_DATA_NAME(state, data) {
      state.createActivityData.name = data;
    },
    SET_ACTIVITY_DATA_DESCRIPTION(state, data) {
      state.createActivityData.description = data;
    },
    SET_ACTIVITY_DATA_IS_TDABC(state, data) {
      state.createActivityData.is_tdabc = data;
    },
    SET_ACTIVITY_DATA_COSTPOOL(state, data) {
      state.createActivityData.costpool = data;
    },
    CLEAR_CREATE_ACTIVITY_DATA(state) {
      state.createActivityData = {
        name: null,
        description: null,
        is_tdabc:false,
        costpool:null
      }
    },
    SET_UPDATE_ACTIVITY_DATA(state, data) {
      state.createActivityData = data
    },
    SET_MODEL_HAS_TDABC_DRIVER(state, data){
      state.modelHasTdabcDriver = data
    }
  },
  actions: {
    getActivitiesTable({ commit }, { context, modelId }) {
      let getUrl = `${activities}?model=${modelId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          console.log("DATA", res.data)
          commit("SET_TABLE_DATA", res.data)
        });
    },
    deleteActivity({ commit }, { context, id }) {
      let deleteUrl = `${activities}${id}`;
      return context.$http.delete(deleteUrl);
    },
    createUpdateAllocationActivity({ state }, { context, modelId, mode }) {
      let dataToPost = {
        model: modelId,
        name: state.createActivityData.name,
        description: state.createActivityData.description,
        is_tdabc: state.createActivityData.is_tdabc,
        costpool: state.createActivityData.costpool
      };
      if (mode == "UPDATE") {
        let putUrl = `${activities}${state.createActivityData.id}/`;
        return context.$http.patch(putUrl, dataToPost);
      }
      let postUrl = `${activities}?model=${modelId}`;
      return context.$http.post(postUrl, dataToPost);
    }
  },
}
